export class ManageInfoLinksModel {
    companyInformationLinkId: string;
    link: string;
    description: string;
    notes: string;
    companyId: number;
}
